import { useEffect } from "react";
import { useFormikContext } from "formik";

const getFirstErrorField = (errors, prefix = "") => {
  for (const key of Object.keys(errors)) {
    const value = errors[key];
    const fieldName = prefix ? `${prefix}.${key}` : key;

    if (typeof value === "string") {
      return fieldName;
    }

    if (typeof value === "object" && value !== null) {
      const nestedField = getFirstErrorField(value, fieldName);
      if (nestedField) return nestedField;
    }
  }

  return null;
};

const FocusErrorField = () => {
  const { errors, isSubmitting, isValidating } = useFormikContext();

  useEffect(() => {
    if (!isSubmitting || isValidating) return;

    const firstErrorField = getFirstErrorField(errors);
    if (!firstErrorField) return;

    setTimeout(() => {
      const field = document.querySelector(
        `[name="${CSS.escape(firstErrorField)}"]`,
      );

      if (field) {
        field.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        field.focus();
      }
    }, 0);
  }, [errors, isSubmitting, isValidating]);

  return null;
};

export default FocusErrorField;